import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _BudgetSource } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../editor/AccountEditor";


export const BudgetSource = () => {

    const BudgetSource = useDataBean(_BudgetSource);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        BudgetSource.instance.getBudgetSourceCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        BudgetSource.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        BudgetSource.deleteItemVoid(BudgetSource.bean.IDBudgetSource).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": ``, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(BudgetSource.bean);
        BudgetSource.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDBudgetSource', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tercero', property: 'IDAccount', visible: true },
        { title: 'Código', property: 'Code', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${BudgetSource.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Fuentes de Financiamiento">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={BudgetSource.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor label="Tercero" idAccount={BudgetSource.bean.IDAccount} onChange={(e) => { BudgetSource.setBean({ ...BudgetSource.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={BudgetSource.bean.Name} onChange={BudgetSource.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={BudgetSource.bean.Code} onChange={BudgetSource.handleChange} />
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {BudgetSource.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}